import { RepConn } from 'src/app/shared/models/datapoint/repconn';
import { DataObject } from 'src/app/shared/models/domain/dataobject';
import { Design } from 'src/app/shared/models/domain/design';
import { SourceWrapper } from '../../transforms/source/source.wrapper';
import { DesignWrapper } from '../../design.wrapper';

export class DMWFactory {
    private static instance: DMWFactory;

    static getInstance() {
        if (!DMWFactory.instance) {
            DMWFactory.instance = new DMWFactory();
        }
        return DMWFactory.instance;
    }

    sourceDatapoints: Array<RepConn>;
    targetDatapoints: Array<RepConn>;
    dataObjects: Array<DataObject>;
    designs: Array<Design>;
    selectedObjects: Array<any>;
    argObj_Id: number;
    tabIndex: number;
    subTabIndex: number;
    importTargetCount: number;
    isCloseClicked: boolean =  false;
    conn_Db_Id: number  = -1;

    /**
     * DMWFactory is a singleton class, so use `DMWFactory.getInstance()` method instead of creating `new DMWFactory()`.
     */
    private constructor() {
        this.sourceDatapoints = new Array<RepConn>();
        this.targetDatapoints = new Array<RepConn>();
        this.dataObjects = new Array<DataObject>();
        this.designs = new Array<Design>();
        this.selectedObjects = new Array<any>();
        this.argObj_Id = -1;
        this.tabIndex = 0;
        this.subTabIndex = 0;
        this.importTargetCount = 0;
        this.isCloseClicked = false;
        this.conn_Db_Id = -1;
    }
    setDefaults() {
        this.sourceDatapoints.splice(0, this.sourceDatapoints.length);
        this.targetDatapoints.splice(0, this.targetDatapoints.length);
        this.dataObjects.splice(0, this.dataObjects.length);
        this.designs.splice(0, this.designs.length);
        this.selectedObjects.splice(0, this.selectedObjects.length);
        this.argObj_Id = -1;
        this.tabIndex = 0;
        this.subTabIndex = 0;
        this.importTargetCount = 0;
        this.isCloseClicked = false;
        this.conn_Db_Id = -1;
    }

    hasSourceRepConn(conn_Id: number): boolean {
        for (let i: number = 0; i < this.sourceDatapoints.length; i++) {
            let srcRepConn = this.sourceDatapoints[i];
            if (srcRepConn.conn.conn_Id == conn_Id) return true;
        }
        return false;
    }

    hasTargetRepConn(conn_Id: number): boolean {
        for (let i: number = 0; i < this.targetDatapoints.length; i++) {
            let tgtRepConn = this.targetDatapoints[i];
            if (tgtRepConn.conn.conn_Id == conn_Id) return true;
        }
        return false;
    }

    getUnmappedSourceWrappers(objectWrapper: DesignWrapper): Array<SourceWrapper> {
        let _unmappedSourceWrappers: Array<SourceWrapper> = new Array<SourceWrapper>();
        let _inLinkObj_Ids: Array<number> = new Array<number>();

        for( let i: number = 0; i < objectWrapper.design.dxMp_Fwd_Lnks.length; i++ ) {
            _inLinkObj_Ids.push( objectWrapper.design.dxMp_Fwd_Lnks[i].obj_Id );
        }
        
        for( let i: number = 0; i < objectWrapper.transformWrappers.length; i++ ) {
           if(objectWrapper.transformWrappers[i].obj_Cd != 'DOBJIS' ) continue;
           let transformWrapper: SourceWrapper = objectWrapper.transformWrappers[i] as SourceWrapper;
            if( transformWrapper.obj_Cd != 'DOBJIS' ) continue;
            
            if( _inLinkObj_Ids.indexOf(transformWrapper.obj_Id) == -1 )
                _unmappedSourceWrappers.push(transformWrapper);
        }
        
        return _unmappedSourceWrappers;
    }

    checkSourceExist( obj_Id: number, objectWrapper: DesignWrapper ) {
        
        for( let i = 0; i < objectWrapper.transformWrappers.length; i++ ){
            let transformWrapper: any = objectWrapper.transformWrappers[i];
            
            if( transformWrapper.code != "SRC" ) continue;
            
            if( transformWrapper.source.dataObject.dObj.conn_Id == obj_Id ) return true;
            
        }
        
        return false;
    }

    checkTargetExist( obj_Id: number, objectWrapper: DesignWrapper ) {
        
        for( let i = 0; i < objectWrapper.transformWrappers.length; i++ ){
            let transformWrapper: any = objectWrapper.transformWrappers[i];
            
            if( transformWrapper.code != "TGT" ) continue;
            
            if( transformWrapper.target.dataObject.dObj.conn_Id == obj_Id ) return true;
            
        }
        return false;
    }
}